import React, { useEffect, useContext, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import makeAnimated from "react-select/animated";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import Select from "react-select";


//functions
import {
  _t,
  getCookie,
  customStyle,
  getSystemSettings
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

//context consumer
import { FinanceContext } from "../../../../../contexts/Finance";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { SettingsContext } from "../../../../../contexts/Settings";

const AccountSettings = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { generalSettings } = useContext(SettingsContext)
  const { branchForSearch } = useContext(RestaurantContext);

  //finance context
  const {
    loading,
    setLoading,

    // account module
    saveData,
    setSaveData,
    accounts,
    setAccounts,

    //module set
    getModuleSetting,
    
    //coa3
    coa3ForSearch,
    coa3ForSearchById,
    getCoaL3,

    //pagination
    dataPaginating,
  } = useContext(FinanceContext);

  const [branch, setBranch] = useState("")
  const [duplicateBranch, setDuplicateBranch] = useState("");

  const isFoodsInn = useMemo(()=>{
    return parseInt(getSystemSettings(generalSettings, "foods_in_setting")) === 1
  },[generalSettings])
    
  //on load
  useEffect(()=>{
    if (getCookie()) {
      getCoaL3();
    }  
  },[]);

  useEffect(()=>{
    if(coa3ForSearchById && branchForSearch){
      setBranch(branchForSearch[0])
      getModuleSetting(coa3ForSearchById, branchForSearch[0])
    }
  },[coa3ForSearchById, branchForSearch]);

  const handleSetBranch = (brnch)=>{
    if(brnch.id !== branch.id){
      setBranch(brnch)
      getModuleSetting(coa3ForSearchById, brnch)
    }
  }

  // handle dropdown functions
  const handleCashAcc = (account) => {
    //for onChange Values
    let cashAccId =  account;
    const valueIds = [];
    let cashArr =  cashAccId.map((cash)=>{
      valueIds.push(cash.id);
      return coa3ForSearchById[cash.id]
    });
    setAccounts((curr)=>({
      ...curr,
      cashAcc: cashArr
    }));
    saveData[0].value = valueIds?.length == 0 ? "" : valueIds
    setSaveData([...saveData]);
  };

  const handleWHT=(account)=>{
    //for onChange Values
    const whtAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      whtAcc: whtAcc
    }));
    //for set values in saveData
    saveData[1].value= account.id
    setSaveData([...saveData]);
  }

  const handleOtherTax=(account)=>{
    //for onChange Values
    const otherTax = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      otherTaxAcc: otherTax
    }));
    //for set values in saveData
    saveData[2].value=account.id
    setSaveData([...saveData]);
  }
  const handleBankAcc=(account)=>{
    //for onChange Values
    let bankAccId = account
    const valueIds = [];
    const bankIdArr = bankAccId.map((bank)=>{
      valueIds.push(bank.id)
      return coa3ForSearchById[bank.id]
    });
    setAccounts((curr)=>({
      ...curr,
      bankAcc: bankIdArr
    }));
    saveData[3].value = valueIds?.length == 0 ? "" : valueIds
    setSaveData([...saveData]);
  }
  const handleInventoryAcc=(account)=>{
    //for onChange Values
    const invAccId = coa3ForSearchById[account.id];;
    setAccounts((curr)=>({
      ...curr,
      invAcc: invAccId
    }));
    //for set values in saveData
    saveData[4].value=account.id
    setSaveData([...saveData]);
  }
  const handleRevAcc=(account)=>{
    //for onChange Values
    const revAccId = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      revAcc: revAccId
    }));
    //for set values in saveData
    saveData[5].value=account.id
    setSaveData([...saveData]);
  }
  const handleCOGS=(account)=>{
    //for onChange Values
    const cogsAccId = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      cogs: cogsAccId
    }));
    //for set values in saveData
    saveData[6].value=account.id
    setSaveData([...saveData]);
  }
  const handlePurchaseDis=(account)=>{
    //for onChange Values
    const purchaseDisId = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      purchaseDis: purchaseDisId
    }));
    //for set values in saveData
    saveData[7].value=account.id
    setSaveData([...saveData]);
  }
  const handleSaleDis=(account)=>{
    //for onChange Values
    const saleDisId = coa3ForSearchById[account.value];
    setAccounts((curr)=>({
      ...curr,
      salesDis: saleDisId
    }));
    //for set values in saveData
    saveData[8].value=account.id
    setSaveData([...saveData]);
  }
  const handlePurchaseTax=(account)=>{
    //for onChange Values
    const purchaseTaxId = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      purchaseTax: purchaseTaxId
    }));
    //for set values in saveData
    saveData[9].value=account.id
    setSaveData([...saveData]);
  }
  const handleSaleTax=(account)=>{
    //for onChange Values
    const saleTaxId = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      salesTax: saleTaxId
    }));
    //for set values in saveData
    saveData[10].value=account.id
    setSaveData([...saveData]);
  }
  const handleSuppCashAcc=(account)=>{
    //for onChange Values
    const suppCashAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      suppCashAcc: suppCashAcc
    }));
    //for set values in saveData
    saveData[11].value=account.id
    setSaveData([...saveData]);
  }
  const handleSuppPayableAcc=(account)=>{
    //for onChange Values
    const suppPayableAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      suppPayableAcc: suppPayableAcc
    }));
    //for set values in saveData
    saveData[12].value=account.id
    setSaveData([...saveData]);
  }

  const handleSuspenseAcc = (account)=>{
    //for onChange Values
    let suspenseAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      suspenseAcc: suspenseAcc
    }));
    //for set values in saveData
    saveData[13].value=account.id
    setSaveData([...saveData]);
  }

  const handleDeliveryAcc = (account)=>{
    //for onChange Values
    let deliveryAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      deliveryAcc: deliveryAcc
    }));
    //for set values in saveData
    saveData[14].value=account.id
    setSaveData([...saveData]);
  }

  const handleServiceAcc = (account)=>{
    //for onChange Values
    let serviceAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      serviceChargesAcc: serviceAcc
    }));
    //for set values in saveData
    saveData[15].value=account.id
    setSaveData([...saveData]);
  }

  const handleFgAcc = (account)=>{
    //for onChange Values
    let fgAcc = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      finishedGoodsAcc: fgAcc
    }));
    //for set values in saveData
    saveData[16].value=account.id
    setSaveData([...saveData]);
  }

  const handleMultiSelect = (key,value,index)=>{
    const acc = value?.length ? value.map((item)=>item.id) : "";
    setAccounts((curr)=>({
      ...curr,
      [key]: value?.length ? value : ""
    }));
    //for set values in saveData
    saveData[index].value= acc
    setSaveData([...saveData]);
  }

  const handleAddCostAcc = (account)=>{
    //for onChange Values
    let addCost = coa3ForSearchById[account.id];
    setAccounts((curr)=>({
      ...curr,
      additionalCostAcc: addCost
    }));
    //for set values in saveData
    saveData[17].value=account.id
    setSaveData([...saveData]);
  }

  const handleAddGrirAcc = (account)=>{
    if(account){
      //for onChange Values
      let grirAccount = coa3ForSearchById[account?.id];
      setAccounts((curr)=>({
        ...curr,
        grirAccount: grirAccount
      }));
      //for set values in saveData
      saveData[18].value= account?.id
      setSaveData([...saveData]);
    }else{
      setAccounts((curr)=>({
        ...curr,
        grirAccount: null
      }));
      //for set values in saveData
      saveData[18].value= ""
      setSaveData([...saveData]);
    }
  }

  const handleAddCustomerAcc = (account)=>{
    setAccounts((curr)=>({
      ...curr,
      customerAccount: account
    }));
    //for set values in saveData
    saveData[22].value=account?.id
    setSaveData([...saveData]);
  }

  const handleAddTransportationAcc = (account)=>{
    setAccounts((curr)=>({
      ...curr,
      transportationAccount: account
    }));
    //for set values in saveData
    saveData[23].value=account?.id
    setSaveData([...saveData]);
  }

  const handleAddAdvanceTaxAcc = (account)=>{
    setAccounts((curr)=>({
      ...curr,
      advanceTaxAcc: account
    }));
    //for set values in saveData
    saveData[24].value=account?.id
    setSaveData([...saveData]);
  }

  const handleStockAdjustmentAcc = (account) => {
    if (account) {
      const stockAdjustmentAccount = coa3ForSearchById[account?.id];
      setAccounts((curr) => ({
        ...curr,
        stockAdjustmentAccount,
      }));
      saveData[25].value = account?.id;
      setSaveData([...saveData]);
    } else {
      setAccounts((curr) => ({
        ...curr,
        stockAdjustmentAccount: null,
      }));
      saveData[25].value = "";
      setSaveData([...saveData]);
    }
  };

  const checkAccounts = () =>{
    if(saveData[0].value != "" && saveData[1].value != "" &&
      saveData[2].value != "" && saveData[3].value != "" &&
      saveData[7].value != "" && saveData[8].value != "" && 
      saveData[9].value != "" && saveData[10].value != "" && 
      saveData[11].value != "" && saveData[12].value != "" && 
      saveData[13].value != "" && saveData[14].value != "" && 
      saveData[15].value != "" && saveData[16].value != "" && 
      saveData[17].value != "" && (isFoodsInn ? (saveData[19].value != "" && 
      saveData[20].value != "" && saveData[21].value != "") : 
      (saveData[4].value != "" && saveData[5].value != "" &&
      saveData[24].value != "" && saveData[6].value != ""))
      ){
      return true
    }else{
      toast.error(`${_t(t("Please select all dropdowns"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }
  }

  const saveAccountsData = (formData) =>{
    const moduleUrl = BASE_URL + `/settings/create-module-setting`;
    // validate all dropdowns
    if(checkAccounts()){
      setLoading(true);
      return axios
      .post(moduleUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLoading(false);
        toast.success(`${_t(t("Module settings has been saved"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        if(formData.branch_id?.length){
          document.getElementById('close-modal').click();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
          
      });
    }
  }

  const handleMultiBranchSubmit = (e) =>{
    e.preventDefault();
    if(!duplicateBranch || duplicateBranch?.length === 0){
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return
    }
    const duplicate = duplicateBranch && duplicateBranch.map((item) => item.id);
    let formData = {
      branch_id: duplicate,
      module_settings: saveData
    }
    saveAccountsData(formData)
  }

  const saveAccounts=(e)=>{
    e.preventDefault();
    if(!branch){
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return
    }
    let formData = {
      branch_id: branch.id,
      module_settings: saveData
    }
    saveAccountsData(formData)
  }
  const customSelectStyle={
    control: (baseStyles) => ({
      ...baseStyles,
      fontSize:"14px"
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    singleValue: (provided) => ({
      ...provided,
      alignSelf: "center",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '8rem',
      overflowY: 'auto',
      flexWrap: 'wrap',
      marginTop: "0",
      padding: "0 0.5rem",
    }),
  }
  return (
    <>
    <Helmet>
      <title>{_t(t("Module Settings"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <AccountsSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading || dataPaginating}/>
                  {/* spin loading ends */}
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-6 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize ml-3">
                                {_t(t("Module Settings"))}
                              </span>
                            </li>
                          </ul>
                        </div>

                        <div className="col-6 t-mb-15 mb-md-0 d-flex align-items-center justify-content-end">
                          <div className="mr-3">
                            <button
                              className="btn btn-primary btn-sm rounded-sm px-3"
                              data-toggle="modal" 
                              data-target="#accountsModal"
                            >
                              {_t(t("Copy Setting"))}
                            </button>
                          </div>
                          <div className="text-end w-50 mr-2">
                            <Select
                              options={branchForSearch ? branchForSearch : []}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              value={branch || ""}
                              classNamePrefix="select table-text"
                              onChange={(branch)=>handleSetBranch(branch)}
                              placeholder={
                                _t(t("Please select branch")) + ".."
                              }
                              styles={customStyle}
                              required
                            />
                          </div>
                        </div>

                      {/* Form starts here */}
                      <div className="row">
                        <form
                          className="card p-3 mx-3 sm-text my-2"
                          onSubmit={(e)=>saveAccounts(e)}
                        >
                          <div className="form-group mt-2 row">
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Cash Accounts <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="auto"
                              minMenuHeight={300}
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) =>
                                option.level3_name
                              }
                              getOptionValue={(option) =>
                                option.id
                              }
                              value={accounts.cashAcc}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isMulti
                              isClearable
                              closeMenuOnSelect={false}
                              maxMenuHeight="200px"
                              onChange={handleCashAcc}
                              placeholder={
                                _t(
                                  t("Please select cash accounts")
                                ) + ".."
                              }
                              styles={customSelectStyle}
                            />
                          </div>
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Withholding Tax Account <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="auto"
                              minMenuHeight={300}
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.level3_name}
                              getOptionValue={(option) => option.id}
                              classNamePrefix="account"
                              className="xsm-text"
                              onChange={handleWHT}
                              maxMenuHeight="200px"
                              placeholder={
                                _t(
                                  t("Please select withholding tax account")
                                ) + ".."
                              }
                              value={accounts.whtAcc}
                              styles={customSelectStyle}                 
                            />
                          </div>
                          </div>
                          <div className="form-group mt-3 row">
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Other Tax Account <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="auto"
                              minMenuHeight={300}
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.level3_name}
                              getOptionValue={(option) => option.id}
                              classNamePrefix="account"
                              className="xsm-text"
                              onChange={handleOtherTax}
                              maxMenuHeight="200px"
                              placeholder={
                                _t(
                                  t("Please select other tax account")
                                ) + ".."
                              }
                              value={accounts.otherTaxAcc}
                              styles={customSelectStyle}
                            />
                          </div>
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Bank Accounts <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="auto"
                              minMenuHeight={300}
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) =>
                                option.level3_name
                              }
                              getOptionValue={(option) =>
                                option.id
                              }
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isMulti
                              isClearable
                              closeMenuOnSelect={false}
                              maxMenuHeight="200px"
                              onChange={handleBankAcc}
                              placeholder={
                                _t(
                                  t("Please select bank accounts")
                                ) + ".."
                              }
                              value={accounts.bankAcc}
                              styles={customSelectStyle}
                            />
                          </div>
                          </div>
                          <div className="form-group mt-3 row">
                          <div className="col-6">
                          <div className="genAcc-select mb-1">Inventory Account<span className="text-danger">*</span></div>
                            {
                              isFoodsInn ? (
                                <Select
                                  menuPlacement="auto"
                                  minMenuHeight={300}
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  isMulti
                                  onChange={(acc)=>handleMultiSelect("fInvAcc",acc,19)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select inventory account")
                                    ) + ".."
                                  }
                                  value={accounts.fInvAcc}
                                  styles={customSelectStyle}
                                />
                              ) : (
                                <Select
                                  menuPlacement="auto"
                                  minMenuHeight={300}
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  onChange={handleInventoryAcc}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select inventory account")
                                    ) + ".."
                                  }
                                  value={accounts.invAcc}
                                  styles={customSelectStyle}
                                />
                              )
                            }
                          </div>
                          <div className="col-6">
                          <div className="genAcc-select mb-1">Revenue Account <span className="text-danger">*</span></div>
                            {
                              isFoodsInn ? (
                                <Select
                                  menuPlacement="auto"
                                  minMenuHeight={300}
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  isMulti
                                  onChange={(acc)=>handleMultiSelect("fRevAcc",acc,20)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select revenue account")
                                    ) + ".."
                                  }
                                  value={accounts.fRevAcc}
                                  styles={customSelectStyle}
                                />
                              ) : (
                                <Select
                                  menuPlacement="auto"
                                  minMenuHeight={300}
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  onChange={handleRevAcc}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select revenue account")
                                    ) + ".."
                                  }
                                  value={accounts.revAcc}
                                  styles={customSelectStyle}                   
                                />
                              )
                            }
                          </div>
                          </div>
                          <div className="form-group mt-3 row">
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Cost of good sold <span className="text-danger">*</span></div>
                            {
                              isFoodsInn ? (
                                <Select
                                  menuPlacement="auto"
                                  minMenuHeight={300}
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  isMulti
                                  onChange={(acc)=>handleMultiSelect("fCogs",acc,21)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select cost of good sold")
                                    ) + ".."
                                  }
                                  value={accounts.fCogs}
                                  styles={customSelectStyle}
                                />
                              ) : (
                                <Select
                                  menuPlacement="top"
                                  options={coa3ForSearch ? coa3ForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.level3_name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="account"
                                  className="xsm-text"
                                  onChange={handleCOGS}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(
                                      t("Please select cost of good sold")
                                    ) + ".."
                                  }
                                  value={accounts.cogs}    
                                  styles={customSelectStyle}               
                                />
                              )}
                              
                            </div>
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Purchase Discount <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="top"
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.level3_name}
                              getOptionValue={(option) => option.id}
                              classNamePrefix="account"
                              className="xsm-text"
                              onChange={handlePurchaseDis}
                              maxMenuHeight="200px"
                              placeholder={
                                _t(
                                  t("Please select purchase discount")
                                ) + ".."
                              }
                              value={accounts.purchaseDis}   
                              styles={customSelectStyle}                
                            />
                          </div>
                          </div>
                          <div className="form-group mt-3 row">
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Sales Discount <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="top"                              
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.level3_name}
                              getOptionValue={(option) => option.id}
                              classNamePrefix="account"
                              className="xsm-text"
                              onChange={handleSaleDis}
                              maxMenuHeight="200px"
                              placeholder={
                                _t(
                                  t("Please select sales discount")
                                ) + ".."
                              }
                              value={accounts.salesDis}    
                              styles={customSelectStyle}               
                            />
                          </div>
                          <div className="col-6">
                          <div className="genAcc-select mb-1">Purchase Tax <span className="text-danger">*</span></div>
                            <Select
                              menuPlacement="top"                              
                              options={coa3ForSearch ? coa3ForSearch : []}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.level3_name}
                              getOptionValue={(option) => option.id}
                              classNamePrefix="account"
                              className="xsm-text"
                              onChange={handlePurchaseTax}
                              maxMenuHeight="200px"
                              placeholder={
                                _t(
                                  t("Please select purchase tax")
                                ) + ".."
                              }
                              value={accounts.purchaseTax} 
                              styles={customSelectStyle}                  
                            />
                          </div>
                          </div>
                          <div className="form-group mt-3 row">
                          <div className="col-6">
                            <div className="genAcc-select mb-1">Sales Tax <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleSaleTax}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select sales tax")
                                  ) + ".."
                                }
                                value={accounts.salesTax}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1">Supplier Cash Account <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleSuppCashAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select supplier account")
                                  ) + ".."
                                }
                                value={accounts.suppCashAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>                          
                          </div>

                          <div className="form-group mt-3 row">
                            <div className="col-6">
                              <div className="genAcc-select mb-1">Supplier Payable Account<span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleSuppPayableAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select payable account")
                                  ) + ".."
                                }
                                value={accounts.suppPayableAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1">Suspense Account<span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleSuspenseAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select suspense account")
                                  ) + ".."
                                }
                                value={accounts.suspenseAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                          </div>

                          <div className="form-group mt-3 row">
                            <div className="col-6">
                              <div className="genAcc-select mb-1"> Delivery Acccount <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleDeliveryAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select delivery account")
                                  ) + ".."
                                }
                                value={accounts.deliveryAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1">Service Charges Account <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleServiceAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select s.c account")
                                  ) + ".."
                                }
                                value={accounts.serviceChargesAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                          </div>

                          <div className="form-group mt-3 row">
                            <div className="col-6">
                              <div className="genAcc-select mb-1"> Finish Goods Account <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleFgAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select fg account")
                                  ) + ".."
                                }
                                value={accounts.finishedGoodsAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1">Additional Cost Account <span className="text-danger">*</span></div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                className="xsm-text"
                                onChange={handleAddCostAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select add cost account")
                                  ) + ".."
                                }
                                value={accounts.additionalCostAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                          </div>

                          <div className="form-group mt-3 row">
                          <div className="col-6">
                              <div className="genAcc-select mb-1"> Customer Acccount </div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                isClearable
                                className="xsm-text"
                                onChange={handleAddCustomerAcc}
                                maxMenuHeight="200px"
                                placeholder={t("Please select customer account")+ ".."}
                                value={accounts.customerAccount}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1"> Grir Acccount </div>
                              <Select
                                menuPlacement="top"                               
                                options={coa3ForSearch ? coa3ForSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                isClearable
                                className="xsm-text"
                                onChange={handleAddGrirAcc}
                                maxMenuHeight="200px"
                                placeholder={
                                  _t(
                                    t("Please select grir account")
                                  ) + ".."
                                }
                                value={accounts.grirAccount}   
                                styles={customSelectStyle}                
                              />
                            </div>
                          </div>
                          <div className="form-group mt-3 row">
                            <div className="col-6">
                              <div className="genAcc-select mb-1"> Transportation Account </div>
                              <Select
                                menuPlacement="top"                               
                                className="xsm-text"
                                options={coa3ForSearch ? coa3ForSearch : []}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                isClearable
                                onChange={handleAddTransportationAcc}
                                maxMenuHeight="200px"
                                placeholder={t("Please select transportation account")+ ".."}
                                value={accounts.transportationAccount}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6">
                              <div className="genAcc-select mb-1"> Advance Tax Account </div>
                              <Select
                                menuPlacement="top"                               
                                className="xsm-text"
                                options={coa3ForSearch ? coa3ForSearch : []}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                isClearable
                                onChange={handleAddAdvanceTaxAcc}
                                maxMenuHeight="200px"
                                placeholder={t("Please select advance tax account")+ ".."}
                                value={accounts.advanceTaxAcc}   
                                styles={customSelectStyle}                
                              />
                            </div>
                            <div className="col-6 mt-2">
                              <div className="genAcc-select mb-1"> Stock Adjustment Account </div>
                              <Select
                                menuPlacement="top"
                                className="xsm-text"
                                options={coa3ForSearch ? coa3ForSearch : []}
                                getOptionLabel={(option) => option.level3_name}
                                getOptionValue={(option) => option.id}
                                classNamePrefix="account"
                                isClearable
                                onChange={handleStockAdjustmentAcc}
                                maxMenuHeight="200px"
                                placeholder={t("Please select stock adjustment account") + ".."}
                                value={accounts.stockAdjustmentAccount}
                                styles={customSelectStyle}
                              />
                            </div>
                          </div>

                          <div className="form-group mt-4 pb-2">
                            <div className="col-12 text-right">
                              <button
                                className="btn btn-primary px-4 rounded"
                                type="submit"
                              >
                                {_t(t("Save"))}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                 </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
      {/*upload csv Modal*/}
      <div
        className="modal fade"
        id="accountsModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md mt-5">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                id="close-modal"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  setDuplicateBranch("")
                }}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form 
                onSubmit={handleMultiBranchSubmit} 
                autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Select Branch"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br/>
                    <Select
                      options={branchForSearch ? branchForSearch.filter((item)=> item.id !== branch.id) : []}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      value={duplicateBranch || ""}
                      classNamePrefix="select table-text"
                      isMulti
                      onChange={(branch)=>setDuplicateBranch(branch)}
                      placeholder={
                        _t(t("Please select branch")) + ".."
                      }
                      styles={customStyle}
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                    disabled={loading}
                    type="submit"
                    className="btn btn-primary print-text text-uppercase px-3 py-2 my-4 rounded"
                    >
                      {_t(t("Submit"))}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  </>
  )
}

export default AccountSettings